// KAZVEN — scripts propios (prefijo mt-). Vanilla JS, sin librerías externas.
var MT_ES = (document.documentElement.lang || '').toLowerCase().indexOf('es') === 0;
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initMarqueeVelocidad();
  initIngredientesEscena();
  initContador();
  initProductoGaleria();
  initProductoVariantes();
  initComparador();
  initProductoFormBono();
  initProductoFormCarrito();
  initVideoLazy();
  initExitPopup();
  initRitualCrossSell();
  initCartBump();
  initScentBump();
  initResenasCarrusel();
  initStickyATC();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el, i) {
    if (!el.style.getPropertyValue('--mt-delay')) {
      el.style.setProperty('--mt-delay', (Math.min(i % 4, 3) * 0.12) + 's');
    }
    obs.observe(el);
  });
}

function initVideoLazy() {
  var videos = document.querySelectorAll('[data-mt-video]');
  if (!videos.length) return;

  if (!('IntersectionObserver' in window)) {
    videos.forEach(function (v) {
      v.src = v.dataset.src;
      v.play().catch(function () {});
    });
    return;
  }

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting) {
        if (!v.src) v.src = v.dataset.src;
        v.play().catch(function () {});
      } else {
        v.pause();
      }
    });
  }, { threshold: 0.35 });

  videos.forEach(function (v) { obs.observe(v); });
}

function initMarqueeVelocidad() {
  document.querySelectorAll('[data-mt-marquee-duracion]').forEach(function (el) {
    var track = el.querySelector('.mt-marquee__track, .mt-resenas-marquee__track');
    if (track) track.style.animationDuration = el.dataset.mtMarqueeDuracion + 's';
  });
}

function initIngredientesEscena() {
  var escenas = document.querySelectorAll('[data-mt-ingredientes]');
  escenas.forEach(function (escena) {
    var items = escena.querySelectorAll('.mt-ingrediente-item');
    var imgs = escena.querySelectorAll('.mt-ingredientes__visual img');
    if (!items.length) return;

    function activar(index) {
      items.forEach(function (it, i) { it.classList.toggle('mt-activo', i === index); });
      imgs.forEach(function (im, i) { im.classList.toggle('mt-activo', i === index); });
    }

    items.forEach(function (item, index) {
      item.addEventListener('click', function () { activar(index); });
      item.addEventListener('mouseenter', function () {
        if (window.matchMedia('(min-width: 991px)').matches) activar(index);
      });
    });

    if ('IntersectionObserver' in window && window.matchMedia('(min-width: 991px)').matches) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var idx = Array.prototype.indexOf.call(items, entry.target);
            if (idx > -1) activar(idx);
          }
        });
      }, { threshold: 0.6 });
      items.forEach(function (item) { obs.observe(item); });
    }

    activar(0);
  });
}

function initContador() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseFloat(el.dataset.mtContador) || 0;
      var decimales = (el.dataset.mtContador.split('.')[1] || '').length;
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = valor.toFixed(decimales);
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin.toFixed(decimales);
      }
      requestAnimationFrame(paso);
      obs.unobserve(el);
    });
  }, { threshold: 0.6 });
  els.forEach(function (el) { obs.observe(el); });
}

function initComparador() {
  document.querySelectorAll('[data-mt-comparador]').forEach(function (comparador) {
    var frame = comparador.querySelector('.mt-comparador__frame');
    var range = comparador.querySelector('.mt-comparador__range');
    var pista = comparador.querySelector('[data-mt-comparador-pista]');
    if (!frame || !range) return;

    function fijar(valor) {
      frame.style.setProperty('--mt-pos', valor + '%');
    }
    fijar(range.value);
    range.addEventListener('input', function () { fijar(range.value); });

    function posicionDesdeCliente(clientX) {
      var rect = frame.getBoundingClientRect();
      var ratio = (clientX - rect.left) / rect.width;
      ratio = Math.max(0, Math.min(1, ratio));
      return Math.round(ratio * 100);
    }

    function ocultarPista() {
      if (pista) pista.classList.add('mt-oculto');
    }
    range.addEventListener('input', ocultarPista, { once: true });

    var arrastrando = false;
    frame.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      ocultarPista();
      var valor = posicionDesdeCliente(e.clientX);
      range.value = valor;
      fijar(valor);
    });
    window.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      var valor = posicionDesdeCliente(e.clientX);
      range.value = valor;
      fijar(valor);
    });
    window.addEventListener('pointerup', function () { arrastrando = false; });
  });
}

function initProductoGaleria() {
  var galeria = document.querySelector('[data-mt-producto-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('.mt-producto__principal img');
  var minis = galeria.querySelectorAll('.mt-producto__miniatura');
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.dataset.full;
      if (src && principal) principal.src = src;
      minis.forEach(function (m) { m.classList.remove('mt-activo'); });
      mini.classList.add('mt-activo');
    });
  });
}

function initProductoFormBono() {
  var form = document.querySelector('[data-mt-producto-form]');
  if (!form || !form.dataset.bonusVariantId) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var idInput = form.querySelector('input[name="id"]');
    var submitBtn = form.querySelector('[data-mt-submit]');
    var items = [
      { id: parseInt(idInput.value, 10), quantity: 1 },
      { id: parseInt(form.dataset.bonusVariantId, 10), quantity: 1 }
    ];

    if (submitBtn) submitBtn.disabled = true;

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(res); })
      .then(function (respuesta) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && respuesta.sections) {
          drawer.renderContents(respuesta);
          if (window.mtIntentarBumpAutomatico) window.mtIntentarBumpAutomatico();
          if (submitBtn) submitBtn.disabled = false;
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        if (submitBtn) submitBtn.disabled = false;
        HTMLFormElement.prototype.submit.call(form);
      });
  });
}

function initProductoFormCarrito() {
  var form = document.querySelector('[data-mt-producto-form]');
  if (!form || form.dataset.bonusVariantId) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var submitBtn = form.querySelector('[data-mt-submit], button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    var formData = new FormData(form);
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: formData
    })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(res); })
      .then(function (respuesta) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && respuesta.sections) {
          drawer.renderContents(respuesta);
          if (window.mtIntentarBumpAutomatico) window.mtIntentarBumpAutomatico();
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (submitBtn) submitBtn.disabled = false;
      })
      .catch(function () {
        if (submitBtn) submitBtn.disabled = false;
        HTMLFormElement.prototype.submit.call(form);
      });
  });
}

function initProductoVariantes() {
  var form = document.querySelector('[data-mt-producto-form]');
  if (!form) return;
  var dataEl = form.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var botones = form.querySelectorAll('.mt-producto__valor');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = form.querySelector('[data-mt-precio-actual]');
  var precioAnteriorEl = form.querySelector('[data-mt-precio-anterior]');
  var submitBtn = form.querySelector('[data-mt-submit]');
  var agotadoMsg = form.querySelector('[data-mt-agotado]');

  var seleccion = {};
  botones.forEach(function (b) {
    if (b.classList.contains('mt-activo')) seleccion[b.dataset.opcion] = b.dataset.valor;
  });

  function encontrarVariante() {
    return variantes.find(function (v) {
      return v.opciones.every(function (val, i) { return seleccion[i] === val || Object.values(seleccion)[i] === val; });
    }) || variantes.find(function (v) {
      return Object.keys(seleccion).every(function (k) { return v.opciones[k] === seleccion[k]; });
    });
  }

  function actualizar() {
    var variante = variantes.find(function (v) {
      return v.opciones.every(function (val, idx) { return val === seleccion[idx]; });
    });
    if (!variante) return;
    if (idInput) idInput.value = variante.id;
    if (precioEl) precioEl.textContent = variante.precio;
    if (precioAnteriorEl) {
      if (variante.precioAnterior) { precioAnteriorEl.textContent = variante.precioAnterior; precioAnteriorEl.style.display = ''; }
      else precioAnteriorEl.style.display = 'none';
    }
    var disponible = variante.disponible;
    if (submitBtn) {
      submitBtn.disabled = !disponible;
      submitBtn.textContent = disponible ? submitBtn.dataset.textoDisponible : submitBtn.dataset.textoAgotado;
    }
    if (agotadoMsg) agotadoMsg.style.display = disponible ? 'none' : '';
  }

  botones.forEach(function (b) {
    b.addEventListener('click', function () {
      var grupo = b.dataset.opcion;
      form.querySelectorAll('.mt-producto__valor[data-opcion="' + grupo + '"]').forEach(function (x) { x.classList.remove('mt-activo'); });
      b.classList.add('mt-activo');
      seleccion[grupo] = b.dataset.valor;
      actualizar();
    });
  });
}

function initExitPopup() {
  var popup = document.querySelector('[data-mt-exit-popup]');
  if (!popup) return;

  function cerrar() {
    popup.classList.remove('mt-visible');
    document.body.style.overflow = '';
    setTimeout(function () { popup.hidden = true; }, 350);
  }
  popup.querySelectorAll('[data-mt-exit-close]').forEach(function (el) {
    el.addEventListener('click', cerrar);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !popup.hidden) cerrar();
  });

  if (popup.hasAttribute('data-mt-exit-auto-show')) {
    popup.hidden = false;
    setTimeout(function () { popup.classList.add('mt-visible'); }, 10);
    document.body.style.overflow = 'hidden';
    return;
  }

  var STORAGE_KEY = 'mt_exit_popup_last_shown';
  var SIETE_DIAS_MS = 7 * 24 * 60 * 60 * 1000;

  var ultimaVez = 0;
  try { ultimaVez = parseInt(localStorage.getItem(STORAGE_KEY), 10) || 0; } catch (e) {}
  if (Date.now() - ultimaVez < SIETE_DIAS_MS) return;

  var yaDisparado = false;

  function carritoAbierto() {
    var drawer = document.querySelector('cart-drawer');
    return !!(drawer && drawer.classList.contains('active'));
  }

  function mostrar() {
    if (yaDisparado) return;
    if (carritoAbierto()) return;
    yaDisparado = true;
    popup.hidden = false;
    setTimeout(function () { popup.classList.add('mt-visible'); }, 10);
    document.body.style.overflow = 'hidden';
    try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
    var input = popup.querySelector('.mt-exit-popup__input');
    if (input) setTimeout(function () { input.focus(); }, 300);
    document.removeEventListener('mouseout', alSalirMouse);
    window.removeEventListener('scroll', alScrollRapido);
    clearTimeout(temporizadorMovil);
  }

  function alSalirMouse(e) {
    if (e.clientY <= 0 && e.relatedTarget === null) mostrar();
  }

  var esMovil = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  var temporizadorMovil;
  var ultimoScrollY = window.scrollY;
  var ultimoScrollT = Date.now();

  function alScrollRapido() {
    if (carritoAbierto()) {
      ultimoScrollY = window.scrollY;
      ultimoScrollT = Date.now();
      return;
    }
    var ahora = Date.now();
    var deltaY = ultimoScrollY - window.scrollY;
    var deltaT = ahora - ultimoScrollT;
    if (deltaT > 0 && deltaT < 250 && deltaY > 90 && window.scrollY > 150) {
      mostrar();
    }
    ultimoScrollY = window.scrollY;
    ultimoScrollT = ahora;
  }

  if (esMovil) {
    temporizadorMovil = setTimeout(mostrar, 45000);
    window.addEventListener('scroll', alScrollRapido, { passive: true });
  } else {
    document.addEventListener('mouseout', alSalirMouse);
  }
}

function actualizarBurbujaCarrito(cantidad) {
  var icono = document.getElementById('cart-icon-bubble');
  if (!icono) return;
  var burbuja = icono.querySelector('.cart-count-bubble');
  if (cantidad > 0) {
    if (!burbuja) {
      burbuja = document.createElement('div');
      burbuja.className = 'cart-count-bubble';
      icono.appendChild(burbuja);
    }
    burbuja.innerHTML =
      (cantidad < 100 ? '<span aria-hidden="true">' + cantidad + '</span>' : '') +
      '<span class="visually-hidden">' + cantidad + ' items</span>';
  } else if (burbuja) {
    burbuja.remove();
  }
}

function initCartBump() {
  function dismissKeyPara(variantId) {
    return 'mt_bump_dismissed_' + variantId;
  }

  function actualizarTotal() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        actualizarBurbujaCarrito(cart.item_count);
        document.querySelectorAll('[data-mt-cart-total]').forEach(function (el) {
          el.textContent = mtFormatearDinero(cart.total_price);
        });
      });
  }

  function mtFormatearDinero(centavos) {
    return '$' + (centavos / 100).toFixed(2);
  }

  function agregarBump(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    });
  }

  function quitarBump(variantId) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(variantId), quantity: 0 })
    });
  }

  // Los dos regalos (guía + parches) van solo con el kit. El descuento automático los deja en $0
  // únicamente cuando el kit y los DOS regalos están juntos en el carrito; si falta uno, el otro
  // se cobra a precio completo aunque la etiqueta diga "Free" (pasaba al agregar el kit con la
  // barra fija de celular, que solo agregaba el kit).
  var KIT_PRODUCT_IDS = [8168174551149, 15390494523501, 15390494654573];
  var GUIDE_VARIANT_ID = 45477165760621;

  function intentarBumpAutomatico() {
    var labels = document.querySelectorAll('[data-mt-bump]');
    if (!labels.length) return;
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var hayKit = cart.items.some(function (item) { return KIT_PRODUCT_IDS.indexOf(item.product_id) !== -1; });
        if (!hayKit) return;
        var hayGuia = cart.items.some(function (item) { return item.variant_id === GUIDE_VARIANT_ID; });
        var guiaLista = hayGuia ? Promise.resolve() : agregarBump(GUIDE_VARIANT_ID).catch(function () {});
        guiaLista.then(function () {
          labels.forEach(function (label) {
            var checkbox = label.querySelector('[data-mt-bump-checkbox]');
            if (!checkbox || checkbox.checked) return;
            var yaRechazado = false;
            try { yaRechazado = localStorage.getItem(dismissKeyPara(label.dataset.variantId)) === '1'; } catch (e) {}
            if (yaRechazado) return;
            agregarBump(label.dataset.variantId).then(function () {
              checkbox.checked = true;
              actualizarTotal();
            }).catch(function () {});
          });
          if (!hayGuia) actualizarTotal();
        });
      });
  }

  // Se corre al cargar la página (cliente que vuelve con carrito ya armado) Y se expone
  // en window para que cualquier flujo que agregue algo al carrito por AJAX (sin recargar
  // la página) pueda volver a intentarlo — antes solo corría una vez al cargar, así que un
  // cliente nuevo (carrito vacío al entrar) que agregaba el Bundle nunca recibía el parche
  // gratis automático, aunque la etiqueta dijera "Added automatically".
  intentarBumpAutomatico();
  window.mtIntentarBumpAutomatico = intentarBumpAutomatico;

  document.addEventListener('change', function (e) {
    var checkbox = e.target.closest('[data-mt-bump-checkbox]');
    if (!checkbox) return;
    var contenedor = checkbox.closest('[data-mt-bump]');
    if (!contenedor) return;

    if (checkbox.checked) {
      try { localStorage.removeItem(dismissKeyPara(contenedor.dataset.variantId)); } catch (err) {}
      agregarBump(contenedor.dataset.variantId).then(actualizarTotal).catch(function () {
        checkbox.checked = false;
      });
    } else {
      try { localStorage.setItem(dismissKeyPara(contenedor.dataset.variantId), '1'); } catch (err) {}
      quitarBump(contenedor.dataset.variantId).then(actualizarTotal);
    }
  });
}

function initScentBump() {
  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-mt-scent-boton]');
    if (!boton || boton.disabled) return;

    var textoSpan = boton.querySelector('[data-mt-scent-texto]');
    var textoOriginal = textoSpan ? textoSpan.textContent : '';
    var variantId = parseInt(boton.dataset.variantId, 10);
    if (!variantId) return;

    boton.disabled = true;
    if (textoSpan) textoSpan.textContent = MT_ES ? 'Agregando...' : 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(res); })
      .then(function () {
        if (textoSpan) textoSpan.textContent = MT_ES ? '✓ Agregado' : '✓ Added';
        boton.classList.add('mt-agregado');
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-mt-cart-total]').forEach(function (el) {
          el.textContent = '$' + (cart.total_price / 100).toFixed(2);
        });
        actualizarBurbujaCarrito(cart.item_count);
        if (window.mtIntentarBumpAutomatico) window.mtIntentarBumpAutomatico();
      })
      .catch(function () {
        boton.disabled = false;
        if (textoSpan) textoSpan.textContent = textoOriginal;
      });
  });
}

function initRitualCrossSell() {
  document.querySelectorAll('[data-mt-ritual-form]').forEach(function (form) {
    var boton = form.querySelector('[data-mt-ritual-boton]');
    var textoSpan = form.querySelector('[data-mt-ritual-boton-texto]');
    var textoNormal = form.dataset.textoNormal || 'Add to Order';
    var textoAgregado = form.dataset.textoAgregado || (MT_ES ? '¡Agregado!' : 'Added!');
    var variantId = parseInt(form.dataset.variantId, 10);
    var temporizador;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!variantId || boton.disabled) return;
      boton.disabled = true;
      clearTimeout(temporizador);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) { return res.ok ? res.json() : Promise.reject(res); })
        .then(function () {
          if (textoSpan) textoSpan.textContent = textoAgregado;
          boton.classList.add('mt-agregado');
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          actualizarBurbujaCarrito(cart.item_count);
          if (window.mtIntentarBumpAutomatico) window.mtIntentarBumpAutomatico();
          temporizador = setTimeout(function () {
            if (textoSpan) textoSpan.textContent = textoNormal;
            boton.classList.remove('mt-agregado');
            boton.disabled = false;
          }, 2500);
        })
        .catch(function () {
          boton.disabled = false;
          if (textoSpan) textoSpan.textContent = textoNormal;
        });
    });
  });
}

function initResenasCarrusel() {
  document.querySelectorAll('[data-mt-resenas-track]').forEach(function (track) {
    var tarjetas = track.querySelectorAll('[data-mt-resena-card]');
    var puntos = track.parentElement.querySelectorAll('[data-mt-resenas-dot]');
    if (!tarjetas.length || !puntos.length) return;

    puntos.forEach(function (punto) {
      punto.addEventListener('click', function () {
        var tarjeta = tarjetas[parseInt(punto.dataset.indice, 10)];
        if (tarjeta) tarjeta.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });

    if (!('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            var indice = Array.prototype.indexOf.call(tarjetas, entry.target);
            puntos.forEach(function (p, i) { p.classList.toggle('mt-activo', i === indice); });
          }
        });
      },
      { root: track, threshold: [0.6] }
    );

    tarjetas.forEach(function (tarjeta) { obs.observe(tarjeta); });
  });
}

function initStickyATC() {
  var sticky = document.querySelector('[data-mt-sticky-atc]');
  if (!sticky) return;
  var trigger = document.getElementById(sticky.dataset.triggerRef);
  var boton = sticky.querySelector('[data-mt-sticky-boton]');
  if (!trigger || !boton) return;

  var precioEl = sticky.querySelector('[data-mt-sticky-precio]');
  var textoEl = sticky.querySelector('[data-mt-sticky-texto]');
  var spinner = sticky.querySelector('[data-mt-sticky-spinner]');
  var productId = parseInt(sticky.dataset.productId, 10);
  if (MT_ES && textoEl && textoEl.firstChild && textoEl.firstChild.nodeType === 3) { textoEl.firstChild.nodeValue = 'Agregar al carrito – '; }
  var textoOriginal = textoEl ? textoEl.innerHTML : '';
  var idInput = document.querySelector('[data-mt-producto-form] input[name="id"]');
  var enCarrito = false;
  var puedeMostrar = false;

  function refrescarVisibilidad() {
    if (enCarrito || !puedeMostrar) {
      sticky.classList.remove('mt-visible');
      sticky.setAttribute('aria-hidden', 'true');
      boton.setAttribute('tabindex', '-1');
    } else {
      sticky.classList.add('mt-visible');
      sticky.removeAttribute('aria-hidden');
      boton.removeAttribute('tabindex');
    }
  }

  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        puedeMostrar = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        refrescarVisibilidad();
      });
    }, { threshold: 0 });
    obs.observe(trigger);
  }

  var precioActualEl = document.querySelector('[data-mt-precio-actual]');
  if (precioActualEl && precioEl && 'MutationObserver' in window) {
    var mo = new MutationObserver(function () {
      precioEl.textContent = precioActualEl.textContent;
    });
    mo.observe(precioActualEl, { childList: true, characterData: true, subtree: true });
  }

  function variantIdActual() {
    return (idInput && idInput.value) || boton.dataset.variantId;
  }

  if (productId) {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        enCarrito = cart.items.some(function (item) { return item.product_id === productId; });
        refrescarVisibilidad();
      })
      .catch(function () {});
  }

  boton.addEventListener('click', function () {
    if (boton.disabled) return;
    var variantId = parseInt(variantIdActual(), 10);
    if (!variantId) return;

    boton.disabled = true;
    if (spinner) spinner.hidden = false;
    if (textoEl) textoEl.textContent = MT_ES ? 'Agregando...' : 'Adding...';

    // Igual que el botón principal del kit: si el formulario trae regalo (la guía), va junto,
    // y el cajón del carrito se refresca con las secciones devueltas.
    var formProducto = document.querySelector('[data-mt-producto-form]');
    var bonoId = formProducto ? parseInt(formProducto.dataset.bonusVariantId, 10) : 0;
    var items = [{ id: variantId, quantity: 1 }];
    if (bonoId) items.push({ id: bonoId, quantity: 1 });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(res); })
      .then(function (respuesta) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && respuesta.sections) drawer.renderContents(respuesta);
        if (spinner) spinner.hidden = true;
        if (textoEl) textoEl.textContent = MT_ES ? '✓ ¡Agregado!' : '✓ Added!';
        enCarrito = true;
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        actualizarBurbujaCarrito(cart.item_count);
        if (window.mtIntentarBumpAutomatico) window.mtIntentarBumpAutomatico();
        setTimeout(refrescarVisibilidad, 1200);
      })
      .catch(function () {
        if (spinner) spinner.hidden = true;
        if (textoEl) textoEl.innerHTML = textoOriginal;
        boton.disabled = false;
        puedeMostrar = false;
        refrescarVisibilidad();
      });
  });
}
